// useIntersectionObserver.js
import { useRef, useEffect, useState } from 'react';

const useIntersectionObserver = (options) => {
	const [isVisible, setIsVisible] = useState(false);
	const elementRef = useRef(null);

	useEffect(() => {
		const { current: currRef } = elementRef;
		const observer = new IntersectionObserver(([entry]) => {
			setIsVisible(isVisible || entry.isIntersecting);
		}, options);

		if (elementRef.current) {
			observer.observe(currRef);
		}

		return () => {
			if (currRef) {
				observer.unobserve(currRef);
			}
		};
	}, [options, isVisible]);

	return [elementRef, isVisible];
};

export default useIntersectionObserver;
